import { DocPage, Section, DoDont } from "../../components/DocChrome";

export function PrinciplesPage() {
    return (
        <DocPage
            title="Design Principles"
            description="MAEIZ-specific rules that govern every Workspace panel. Derived from operations-first water delivery, not generic SaaS tropes."
        >
            <Section title="Operational clarity">
                <p>
                    Field and office users must see status, balances, and next actions without
                    decoding decoration. Prefer dense, scannable layouts over marketing whitespace.
                </p>
            </Section>
            <Section title="Predictability">
                <p>
                    The same control, size, and state model appears in Owner, Tenant, Rider, and
                    Customer. Role-aware UX changes <em>what</em> is available, not how a Button or
                    Table behaves.
                </p>
            </Section>
            <Section title="Authority with restraint">
                <p>
                    Royal blue carries primary actions. Authority gold (`#C9A736`) is sparingly used
                    for brand prestige, verified states, and critical KPIs — never for warnings or
                    fills.
                </p>
            </Section>
            <Section title="Progressive disclosure">
                <p>
                    Dashboards summarize; detail pages deepen; drawers/modals handle focused tasks.
                    Do not dump every field on the first viewport.
                </p>
            </Section>
            <Section title="Feedback & error prevention">
                <p>
                    Loading, empty, and error states are first-class. Destructive actions require
                    confirmation. Validation is inline and specific.
                </p>
            </Section>
            <Section title="Accessibility">
                <p>
                    WCAG 2.2 AA target: keyboard paths, focus-visible rings, labeled controls,
                    reduced-motion respect.
                </p>
            </Section>
            <DoDont
                doItems={[
                    "Reuse @maeiz/ui components and semantic tokens",
                    "Keep gold for accent/identity only",
                    "Match information density to the role (rider field vs owner admin)",
                ]}
                dontItems={[
                    "Invent panel-specific button styles",
                    "Use gold for warnings (use amber warning)",
                    "Hardcode #hex brand colors in components",
                ]}
            />
        </DocPage>
    );
}
